import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";
import axiosInstance from "../../config/axiosConfig";
import Actions from "../../components/courses/Actions";
import { CircularProgress } from "@mui/material";
import { MAX_SIZE_MB } from "../../helper";

// Styles for modal (customize as needed)
const customModalStyles = {
  content: {
    padding: "20px",
    width: "80%",
    maxWidth: "600px",
    margin: "auto",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
};

const Slider = () => {
  const [sliders, setSliders] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editSliderId, seteditSliderId] = useState(null);
   const [sortByLatest, setSortByLatest] = useState(false);
  const [formData, setformData] = useState({
    img: "",
    title: "",
    description: "",
    redirectLink: "",
    buttonText: "",
  });
  const [sliderFetchLoading, setSliderFetchLoading] = useState(false);
  const [buttonLoading, setbuttonLoading] = useState(false);
  const [imgFile, setImgFile] = useState(null);
    const [imgPreview, setImgPreview] = useState(null);
    useEffect(() => {
      // Set image preview when formData.img changes (for edit case)
      if (formData.img) {
        setImgPreview(formData.img);
      }
    }, [formData.img]);

  useEffect(() => {
    // Fetch sliders on component mount
    fetchSliders();
  }, []);

  // Fetch all sliders
  const fetchSliders = async () => {
    setSliderFetchLoading(true);
    try {
      const response = await axiosInstance.get("slider/all");
      setSliders(response.data.data);
    } catch (error) {
      console.error("Error fetching sliders:", error);
    }
    setSliderFetchLoading(false);
  };

  // Handle create slider
  const handleCreateSlider = async (e) => {
    e.preventDefault();
    setbuttonLoading(true);
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "img") {
        return;
      }
      formDataToSend.append(key, formData[key]);
    });
    if (imgFile) {
      formDataToSend.append("img", imgFile);
    }
    try {
      await axiosInstance.post("slider/create", formDataToSend);
      fetchSliders();
      setShowCreateModal(false);
      Swal.fire("Success!", "Slider created successfully!", "success", 1500);
      setformData({
        img: "",
        title: "",
        description: "",
        redirectLink: "",
        buttonText: "",
      });
      setImgFile(null);
      setImgPreview(null);
    } catch (error) {
      console.error("Error creating slider:", error);
      const message = error.response?.data?.message || "Failed to create slider";
      Swal.fire("Error", message, "error");
    }
    setbuttonLoading(false);
  };

  // Handle edit slider
  const handleEditSlider = async (e) => {
    e.preventDefault();
    setbuttonLoading(true);
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "img") {
        return;
      }
      formDataToSend.append(key, formData[key]);
    });

    if (imgFile) {
      formDataToSend.append("img", imgFile);
    }
    formDataToSend.append("_method", "PUT");
    try {
      await axiosInstance.post(`slider/change/${editSliderId}`, formDataToSend);
      fetchSliders();
      setShowEditModal(false);
      setImgFile(null);
      Swal.fire("Success!", "Slider updated successfully!", "success");
    } catch (error) {
      console.error("Error updating slider:", error);
      const message = error.response?.data?.message || "Failed to update slider";
      Swal.fire("Error", message, "error");
    }
    setbuttonLoading(false);
  };
  const handleViewSlider = async (id) => {
    setShowEditModal(true);

    try {
      setShowEditModal(true);
      seteditSliderId(id);
      const response = await axiosInstance.get(`slider/single/${id}`);
      const data = response?.data?.data;

      setformData({
        title: data.title || "",
        description: data.description || "",
        redirectLink: data.redirectLink || "",
        buttonText: data.buttonText || "",
        img: data.img || "",
      });
    } catch (error) {
      console.error("Error updating slider:", error);
      Swal.fire("Error", "Failed to update slider", "error");
    }
  };
  // Handle delete slider
  const handleDeleteSlider = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.isConfirmed) {
        await axiosInstance.delete(`slider/delete/${id}`);
        fetchSliders();
        Swal.fire("Deleted!", "Slider deleted successfully", "success", 1500);
      }
    } catch (error) {
      console.error("Error deleting slider:", error);
      Swal.fire("Error", "Failed to delete slider", "error");
    }
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setformData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > MAX_SIZE_MB) {
        alert(
          `File size exceeds ${MAX_SIZE_MB} MB. Please upload a smaller file.`
        );
        e.target.value = "";
      } else {
        setImgFile(file);
        setImgPreview(URL.createObjectURL(file));
      }
    }
  };
  const sortedSliders = sortByLatest
  ? [...sliders].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  : sliders || [];
  return (
    <div>
      <p
        style={{
          margin: "0 0 16px",
          padding: "10px 14px",
          background: "#fff8e6",
          border: "1px solid #f0d78c",
          borderRadius: "6px",
          color: "#6b5a1e",
          fontSize: "14px",
        }}
      >
        Note: Only the latest 5 sliders are shown on the website home page.
      </p>
         <div style = {{display: "flex", justifyContent: "space-between"}}>
      <button
        onClick={() => setShowCreateModal(true)}
        style={{
          padding: "10px 20px",
          backgroundColor: "#4CAF50",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          marginBottom: "20px",
          cursor: "pointer",
        }}
      >
        Create New Slider
      </button>
        <button
          onClick={() => setSortByLatest((prev) => !prev)}
          style={{
            padding: "10px 20px",
            backgroundColor: sortByLatest ? "#2196F3" : "#f0f0f0",
            color: sortByLatest ? "#fff" : "#000",
            border: "none",
            borderRadius: "5px",
            marginBottom: "20px",
            cursor: "pointer",
            marginRight: "150px",
          }}
        >
          {sortByLatest ? "Show Default" : "Show Latest"}
        </button>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {sliderFetchLoading ? (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          >
            {" "}
            <CircularProgress />{" "}
          </div>
        ) : (
          sortedSliders.map((slider) => (
            <div
              key={slider._id}
              style={{
                width: "250px",
                padding: "15px",
                borderRadius: "8px",
                backgroundColor: "#fff",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
              }}
            >
              <img
                src={slider.img || "/uo-16-9.webp"}
                alt={slider.title}
                style={{
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginBottom: "15px",
                  aspectRatio: "16/9",
                }}
              />
              <h3>{slider.title}</h3>
              <p>{slider.description}</p>
              <Actions
                courseId={slider._id}
                onEdit={handleViewSlider}
                onDelete={handleDeleteSlider}
              />
            </div>
          ))
        )}
      </div>

      <Modal
        isOpen={showCreateModal}
        onRequestClose={() => setShowCreateModal(false)}
        style={customModalStyles}
        contentLabel="Create New Slider"
      >
        <h2>Create New Slider</h2>
        <form onSubmit={handleCreateSlider}>
          {[
            { label: "Title", name: "title", type: "text" },
            { label: "Description", name: "description", type: "text" },
            { label: "Redirect Link", name: "redirectLink", type: "text" },
            { label: "Button Text", name: "buttonText", type: "text" },
          ].map(({ label, name, type, required }) => (
            <div key={name} style={{ marginBottom: "10px" }}>
              <label
                style={{
                  display: "block",
                  fontWeight: "bold",
                  marginBottom: "5px",
                }}
              >
                {label}
              </label>
              {type === "textarea" ? (
                <textarea
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={required}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    height: "100px",
                  }}
                />
              ) : (
                <input
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={required}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              )}
            </div>
          ))}
          <div style={{ marginBottom: "10px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "5px",
              }}
            >
              Upload Image
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              required
            />
            {imgPreview && (
            <img
              src={imgPreview}
              alt="Preview"
              style={{ width: "30%", height: "auto", marginBottom: "15px" }}
            />
          )}
          </div>
          <button
            type="submit"
            style={{
              padding: "10px 20px",
              backgroundColor: "#4CAF50",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              marginTop: "10px",
            }}
          >
            {buttonLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Create"
            )}
          </button>
        </form>
      </Modal>

      <Modal
        isOpen={showEditModal}
        onRequestClose={() => {
          setformData({
            title: "",
            description: "",
            redirectLink: "",
            buttonText: "",
            img: "",

          })
          setImgPreview(null);
          setShowEditModal(false)

        }}
        style={customModalStyles}
        contentLabel="Edit Slider"
      >
        <h2>Edit Slider</h2>
        <form onSubmit={handleEditSlider}>
          {[
            { label: "Title", name: "title", type: "text" },
            { label: "Description", name: "description", type: "textarea" },
            { label: "Redirect Link", name: "redirectLink", type: "text" },
            { label: "Button Text", name: "buttonText", type: "text" },
          ].map(({ label, name, type, required }) => (
            <div key={name} style={{ marginBottom: "10px" }}>
              <label
                style={{
                  display: "block",
                  fontWeight: "bold",
                  marginBottom: "5px",
                }}
              >
                {label}
              </label>
              {type === "textarea" ? (
                <textarea
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={required}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    height: "100px", // Adjust height as needed
                  }}
                />
              ) : (
                <input
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={name !== "img"}
                  style={{
                    width: "100%",
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              )}
            </div>
          ))}
          <div style={{ marginBottom: "10px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "5px",
              }}
            >
              Upload Image
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
            {imgPreview && (
            <img
              src={imgPreview}
              alt="Preview"
              style={{ width: "30%", height: "auto", marginBottom: "15px" }}
            />
          )}
          </div>
          <button
            type="submit"
            style={{
              padding: "10px 20px",
              backgroundColor: "#4CAF50",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              marginTop: "10px",
            }}
          >
            {buttonLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Update"
            )}
          </button>
        </form>
      </Modal>
    </div>
  );
};

export default Slider;
